import { addMilliseconds, isWithinInterval } from 'date-fns';
import { CACHED_TOKEN_KEY, CACHED_USER_DATA_KEY, TOKEN_STORED } from "@wantable/Config";
import { IUser, ICachedTokenData, IUserAttributes } from "@wantable/Shared/Types";

export const cacheShopifyToken = (apiResponse: any) => {
  const { shopify_uid, shopify_multipass_token } = apiResponse.data.attributes;

  const tokenData = JSON.stringify({
    shopifyToken: shopify_multipass_token,
    shopifyUID: shopify_uid,
  });
  localStorage.setItem(CACHED_TOKEN_KEY, tokenData);
  const event = new Event(TOKEN_STORED, { tokenData } as EventInit);
  window.dispatchEvent(event);
};

export const cacheUserData = (result: { data: IUser }) => {
  const userData = result.data.attributes;

  localStorage.setItem(CACHED_USER_DATA_KEY, JSON.stringify(userData));
};

export const checkSessionStatus = (data: any) => {
  // if this isn't there then assume they just got here from WWW and it will fetch the user momentarily
  if(!data.shopifyToken.updated_at)
    return true;

  const expireDate = new Date(data.shopifyToken.expiry * 1000)

  return isWithinInterval(new Date(), {
    start: new Date(data.shopifyToken.updated_at),
    end: expireDate,
  });
};

export const checkIfLoggedIn = () => {
  const value = localStorage.getItem(CACHED_TOKEN_KEY);
  if (!value) {
    return false;
  };
  return checkSessionStatus(JSON.parse(value));
}

export const getCachedAccessToken = (): ICachedTokenData | null => {
  const value = localStorage.getItem(CACHED_TOKEN_KEY);
  if (!value) {
    return null;
  };
  return JSON.parse(value);
}

export const getCachedUserData = (): IUserAttributes | null => {
  const value = localStorage.getItem(CACHED_USER_DATA_KEY);
  if (!value) {
    return null;
  };
  return JSON.parse(value);
}

export const clearUserSessionCache = () => {
  localStorage.removeItem(CACHED_TOKEN_KEY);
  localStorage.removeItem(CACHED_USER_DATA_KEY);
}
